/**
 * InfinitSales - API Key Service
 * Manages integration API keys (create, list, revoke).
 */
import api from './api';

const apiKeyService = {
  // `scopes` omitido mantem o que a tela sempre criou (leitura + envio de
  // mensagem). Escrita so vai se for pedida com todas as letras: uma chave que
  // altera funil e etapa de um CRM inteiro nao pode nascer por omissao.
  async create(name, scopes) {
    const body = { name };
    if (scopes && scopes.length) body.scopes = scopes;
    const response = await api.post('/api/users/me/api-keys', body);
    return response.data;
  },

  async list() {
    const response = await api.get('/api/users/me/api-keys');
    return response.data;
  },

  async revoke(keyId) {
    const response = await api.delete(`/api/users/me/api-keys/${keyId}`);
    return response.data;
  },
};

export default apiKeyService;
